import { container } from './container'
import { plansStore } from '../store/plansStore'
import { ExtraApi } from '../api/ExtraApi'

/**
 * A set of usefull calls and utils for recurring orders/users
 */
export class RecurringHelper {

  /**
   * Retrieve the total of the shop
   *
   * @param Object value the current info about recurring user
   * @param Array products info about products
   *
   * @return float
   */
  getTotalShop(value, products) {
    let totalShop = 0;

    if (!value.enableShop) {
      return totalShop;
    }

    value.shop.map(i => {
      i = typeof i === 'object' ? i.id : i;
      
      let p = products.find(product => {
        return product.id == i
      })

      if (p) {
        totalShop += parseFloat(p.price)
      }
    })

    return totalShop;
  }
  
  /**
   * Retrieve an array set of all products for recurring
   *
   * @return float
   */
  getItemsShop() {
    return [
      {id: 4972, name: "Verdura Small"},
      {id: 3227, name: "Frutta e Verdura Small"},
      {id: 3228, name: "Frutta Small"},
      {id: 3229, name: "Mista Small"},
      {id: 4973, name: "Verdura Medium"},
      {id: 3217, name: "Frutta e Verdura Medium"}, 
      {id: 3218, name: "Frutta Medium"},
      {id: 3219, name: "Mista Medium"},
      {id: 4974, name: "Verdura Large"},
      {id: 3221, name: "Frutta e Verdura Large"},
      {id: 3222, name: "Frutta Large"},
      {id: 3223, name: "Mista Large"},
    ];
  }

  retrieveInfoAboutItemsShop() {
    let shop = this.getItemsShop();
    let api = new ExtraApi();
    let query = []
    let sort_field = 'id'
    let sort_direction = 'asc'

    query.push(`(id in (${shop.map(i => {return i.id}).join(",")}))`)

    return api.all({params: {
      show: shop.length,
      page: 1,
      query: query.join(" and ")
    }}).then(response => {
      let products = response.body.data.resources.map(product => {
        let x = shop.find(i => {
          return product.id == i.id
        })

        if (x) {
          product.name = x.name += " - € " + product.price
        }

        return product

      })
      return products;
    })
  }

  retrieveInfoAboutPlan(value) {
    return plansStore.loadPlans().then(i => {
      return plansStore.findPlan({
        people: 2,
        meals: value.recipes * value.meals
      })
    })
  }
  
  /**
   * Retrieve the min price gross of an order
   *
   * @return float
   */
  getMinPriceGross() {
    return parseFloat(window.config["quomi.sources.default.min_gross"]) 
  }

  /**
   * Check if the current configuration of value has reached the min price gross for an order
   *
   * @param Object value the current info about recurring user
   *
   * @return bool
   */
  hasRecurringReachedMin(value, products, plan) {
    return this.getMinPriceGross() <= (this.getTotalShop(value, products) + this.getTotalPlan(value, plan))
  }

  getTotalPlan(value, plan) {
    return plan && value.enablePlan ? plan.price : 0
  }
 
  loadAndCheckMin(value) {
    let plan, products;

    return this.retrieveInfoAboutPlan(value).then(i => {
      plan = i;
      return this.retrieveInfoAboutItemsShop(value);
    }).then(i => {
      products = i;
      return this.hasRecurringReachedMin(value, products, plan)
    })
  }
}